<template>
  <div></div>
</template>
<script>
import { getItem } from '@/utils/storage-main.js'
import { isGuest } from '@/utils/guest.js'
import { thirdLoginHanlder } from '@/utils/mutiple.js'

export default {
  data() {
    return {}
  },
  mounted() {
    const query = this.$route.query
    const { params, code } = query
    const redirecturlParams = params ? window.atob(params) : ''
    const type = this.getUrlParams(redirecturlParams, 'type')
    if (code) {
      type === 'linkedin'
        ? this.getLoginCodeLinkedin(redirecturlParams)
        : this.getLoginCode(query)
    } else {
      if (type === 'linkedin') {
        const from = this.getUrlParams(redirecturlParams, 'from')
          ? this.getUrlParams(redirecturlParams, 'from')
          : 'login'
        this.$router.push({
          path: `/${from}/phone/account?${redirecturlParams}`,
        })
      } else {
        let from = query.from
          ? typeof query.from === 'object'
            ? query.from[query.from.length - 1]
            : query.from
          : 'login'
        this.$router.push({
          path: `/${from}/phone/account`,
          query: { ...query },
        })
      }
    }
  },
  methods: {
    handleGetUrlMode(type) {
      let modeObj = {
        wechat_pc: 3,
        wechat_mobile: 4,
        linkedin: 5,
      }
      return modeObj[type]
    },
    getUrlParams(redirecturlParams, type) {
      if (!redirecturlParams) return ''
      let paramsArr = redirecturlParams.split('&')
      let result = paramsArr
        .map((val) => val.split('='))
        .find((v) => {
          if (v[0] === type) return v
        })
      return result && result.length ? result[1] : ''
    },
    getLoginCodeLinkedin(redirecturlParams) {
      const { params, code } = this.$route.query
      const urlCode = code
        ? typeof code === 'object'
          ? code[code.length - 1]
          : code
        : ''
      const type = this.getUrlParams(redirecturlParams, 'type')
      const gi_guest = this.getUrlParams(redirecturlParams, 'gi_guest')
      if (!type || type === 'normal') {
        this.$router.push({ path: `/login/phone/account?${redirecturlParams}` })
      } else {
        // todo
        // 游客三方登录需要传递bind_type
        const call_back_url = `${process.env.VUE_APP_REDIRECT_URI}/linkedin?params=${params}`
        // 第三方登陆
        let paramsData = {
          mode: type,
          code: urlCode,
          call_back_url: call_back_url,
        }
        if (isGuest()) {
          paramsData.bind_type = this.handleGetUrlMode(type)
        }
        this.getAuthCode(paramsData, gi_guest)
      }
    },
    getLoginCode(query) {
      let type = query.type
        ? typeof query.type === 'object'
          ? query.type[query.type.length - 1]
          : query.type
        : ''
      let code = query.code
        ? typeof query.code === 'object'
          ? query.code[query.code.length - 1]
          : query.code
        : ''
      let gi_guest = query.gi_guest
        ? typeof query.gi_guest === 'object'
          ? query.gi_guest[query.gi_guest.length - 1]
          : query.gi_guest
        : ''
      if (!type || type === 'normal') {
        this.$router.push({ name: 'handleSaveAndJump' })
      } else {
        // 第三方登陆
        let params = {
          mode: type,
          code: code,
        }
        if (isGuest()) {
          params.bind_type = this.handleGetUrlMode(type)
        }
        this.getAuthCode(params, gi_guest)
      }
    },
    async getAuthCode(params, gi_guest = '') {
      // 判断游客的绑定逻辑
      thirdLoginHanlder(getItem('business'), params, gi_guest)
    },
  },
}
</script>
